export function groupDaysWithSameHours(hoursObject) {
  const daysOfWeek = [
    { label: "Monday", value: "mon" },
    { label: "Tuesday", value: "tue" },
    { label: "Wednesday", value: "wed" },
    { label: "Thursday", value: "thu" },
    { label: "Friday", value: "fri" },
    { label: "Saturday", value: "sat" },
    { label: "Sunday", value: "sun" },
  ];

  const groupedHours = {};

  daysOfWeek.forEach((day) => {
    const dayValue = day.value;
    const hours = hoursObject[dayValue];
    if (hours) {
      if (!groupedHours[hours]) {
        groupedHours[hours] = [day];
      } else {
        groupedHours[hours].push(day);
      }
    }
  });
  const result = Object.entries(groupedHours).map(([hours, days]) => {
    return {
      days,
      time: hours,
    };
  });
  return result;
}
